export default __webpack_public_path__ + "static/media/IMG_4579-min.8b93fcac.JPG";